import { useQuery } from '@tanstack/react-query'
import {
  fetchAuditLogs,
  type AuditParams,
  type AuditLogResponse,
} from '@/api/audit'

export function useAuditLog(params: AuditParams) {
  return useQuery<AuditLogResponse>({
    queryKey: ['admin', 'audit', params],
    queryFn: () => fetchAuditLogs(params),
  })
}
